import { StoreSlice } from '../types';

export declare type INullableString = string | null;

export declare interface IA11ySlice {
  a11yEnabled: boolean;
  captionsEnabled: boolean;
  descriptionsEnabled: boolean;
  currentDescription: INullableString;
  descriptionsReading: boolean;
  ariaLiveMessage: string | null;
  setCaptionsEnabled: (v: boolean) => void;
  setDescriptionsEnabled: (v: boolean) => void;
  setCurrentDescription: (v: INullableString) => void;
  setDescriptionsReading: (v: boolean) => void;
  setA11yEnabled: (v: boolean) => void;
  setAriaLiveMessage: (v) => void;
}

const createA11ySlice: StoreSlice<IA11ySlice> = (set) => ({
  a11yEnabled: true,
  captionsEnabled: !!(new URLSearchParams(window.location.search).get('captionsEnabled')),
  descriptionsEnabled: !!(new URLSearchParams(window.location.search).get('descriptionsEnabled')),
  currentDescription: null,
  descriptionsReading: false,
  ariaLiveMessage: '',
  setCaptionsEnabled: (v) => set((state) => { state.captionsEnabled = v; }),
  setDescriptionsEnabled: (v) => set((state) => { state.descriptionsEnabled = v; }),
  setCurrentDescription: (v) => set((state) => { state.currentDescription = v; }),
  setDescriptionsReading: (v) => set((state) => { state.descriptionsReading = v; }),
  setA11yEnabled: (v) => set((state) => { state.a11yEnabled = v; }),
  setAriaLiveMessage: (v) => set((state) => { state.ariaLiveMessage = v; }),
});

export default createA11ySlice;
